module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cohort-iv.json
// module id = 673
// module chunks = 99305005047870